import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { KeyboardClickable } from './KeyboardClickable.js';
import { SchoolRequestForm } from './SchoolRequestForm.js';
import { LightBox } from './LightBox.js';


/* global dc, dcAnalytics */

export const SchoolSearchDetails = createReactClass({
    propTypes: {
        location: PropTypes.object.isRequired,
        numTotalTeachers: PropTypes.string,
        userFullName: PropTypes.string,
        userEmail: PropTypes.string,
        schoolDetails: PropTypes.object.isRequired,
        isTeacherRegistrationRequest: PropTypes.bool,
        showUpdateSchoolInfoForm: PropTypes.bool,
        setShowUpdateSchoolInfoForm: PropTypes.func.isRequired,
        clearSelectedSchool: PropTypes.func.isRequired,
    },

    componentDidMount() {
        dcAnalytics.track('School Chosen', {
            'School ID': this.props.schoolDetails.id,
            'School Proof Stats Shown': (this.props.schoolDetails.numTeachers > 0 && this.props.schoolDetails.numPostedProjects > 0),
            'School Proof Teacher Photos Shown': (this.props.schoolDetails.teacherPhotos != null && this.props.schoolDetails.teacherPhotos.length > 0),
            'In teacher registration': (this.props.isTeacherRegistrationRequest === true),
        });
    },

    showUpdateSchoolInfoForm() {
        this.props.setShowUpdateSchoolInfoForm(true);
    },

    hideUpdateSchoolInfoForm() {
        this.props.setShowUpdateSchoolInfoForm(false);
    },

    renderAdditionalTeachersCount() {
        if (this.props.schoolDetails.numTeachers && this.props.schoolDetails.teacherPhotos && this.props.schoolDetails.teacherPhotos.length > 0) {
            var additionalTeachersCount = this.props.schoolDetails.numTeachers - this.props.schoolDetails.teacherPhotos.length;
            if (additionalTeachersCount > 0) {
                return (
                    <div className="and-more">+{additionalTeachersCount} others</div>
                );
            }
        }
    },

    renderTeacherProfilePhotos() {
        if (this.props.schoolDetails.teacherPhotos && this.props.schoolDetails.teacherPhotos.length > 0) {
            return this.props.schoolDetails.teacherPhotos.map((teacherPhoto, index) => {
                return (
                    <div className="avatar" style={{ backgroundImage: 'url(' + teacherPhoto.photoURL + ')' }}><span className="teacher-name">{teacherPhoto.name}</span></div>
                );
            });
        }
    },

    renderProjectsFundedStat() {
        var moreThanOneTeacher = this.props.schoolDetails.numTeachers && this.props.schoolDetails.numTeachers > 1;
        if (this.props.schoolDetails.numTeachers && this.props.schoolDetails.numPostedProjects && this.props.schoolDetails.numPostedProjects > this.props.schoolDetails.numTeachers) {
            return (
                <p className="successful-teachers">{this.props.schoolDetails.numTeachers} {moreThanOneTeacher ? ' teachers ' : ' teacher '} at your school {moreThanOneTeacher ? ' have ' : ' has '} already successfully posted {this.props.schoolDetails.numPostedProjects} {this.props.schoolDetails.numPostedProjects > 1 ? ' projects' : ' project'}!</p>
            );
        } else if (this.props.schoolDetails.numTeachers) {
            return (
                <p className="successful-teachers">{this.props.schoolDetails.numTeachers} {moreThanOneTeacher ? ' teachers ' : ' teacher '} at your school {moreThanOneTeacher ? ' are ' : ' is '} using DonorsChoose!</p>
            );
        } else {
            return (
                <p className="successful-teachers">{this.props.numTotalTeachers ? this.props.numTotalTeachers : '462,177'} teachers across the country have already successfully funded more than a million projects!</p>
            );
        }
    },

    renderUpdateSchoolInfoForm() {
        if (this.props.showUpdateSchoolInfoForm) {
            const lightboxContent = (
                <SchoolRequestForm
                    location={this.props.location}
                    isTeacherRegistrationRequest={this.props.isTeacherRegistrationRequest}
                    isNewRequest={false}
                    schoolId={this.props.schoolDetails.id}
                    userFullName={this.props.userFullName}
                    userEmail={this.props.userEmail}
                    exitHandler={this.hideUpdateSchoolInfoForm}
                />
            );
            return (
                <LightBox
                    content={lightboxContent}
                    lightboxCloseHandler={this.hideUpdateSchoolInfoForm}
                    tier={2}
                />
            );
        }
    },

    getVerificationContactFormLink() {
        return secureBaseURL + 'contact/contact_form.html?supportCategory=5&supportSubCategory=3913&email=' + this.props.userEmail;
    },

    render() {
        return (
            <div className="school-search-found">
                <KeyboardClickable>
                    <a tabIndex="0" className="change-school" onClick={this.props.clearSelectedSchool}>&laquo; Search for a different school</a>
                </KeyboardClickable>
                <div ref={(r) => this.schoolInfoDiv = r} className="school-info">
                    <h3>{this.props.schoolDetails.name}</h3>
                    <div className="teacher-count-details">
                        {this.renderTeacherProfilePhotos()}
                        {this.renderAdditionalTeachersCount()}
                        {this.renderProjectsFundedStat()}
                    </div>
                    <p className="info-line"><span className="label">ADDRESS:</span>
                        <span className="content">{this.props.schoolDetails.address}</span>
                    </p>
                    <p className="info-line"><span className="label">PHONE:</span>
                        <span className="content">{this.props.schoolDetails.phone}</span>
                    </p>
                    <p className="info-line"><span className="label">DISTRICT:</span>
                        <span className="content">{this.props.schoolDetails.district}</span>
                    </p>
                    <p className="correct-address">We'll use this address to ship materials for your funded projects so please make sure the address is correct.&nbsp;
                        <KeyboardClickable>
                            <a tabIndex="0" onClick={this.showUpdateSchoolInfoForm}>Correct this school info.</a>
                        </KeyboardClickable>
                    </p>
                </div>
                {this.renderUpdateSchoolInfoForm()}
            </div>
        );
    },
});
